import React from 'react'
import logoo from './images/logoo.png'
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Form from 'react-bootstrap/Form';

function logobar() {
    return (
        <Navbar expand="lg" className="bg-body-tertiary">
            <Container>
                <Navbar.Brand href="/"><img src={logoo} width={60} height={60} alt='Logo' /></Navbar.Brand>
                <Form className="d-flex">
                    <Form.Control
                        type="search"
                        placeholder="Search"
                        className="me-5"
                        aria-label="Search"
                    />
                </Form>
                <ul className="navbar-nav d-flex flex-row flex-nowrap justify-content-center align-items-center gap-3">
                    <li className="nav-item">
                        <a className="nav-link d-flex align-items-center gap-1" href="mailto:info@esellersupport.com">
                            <ion-icon name="mail-unread-outline"></ion-icon>
                            info@esellersupport.in
                        </a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link d-flex align-items-center gap-1" href="tel:+918527203697">
                            <ion-icon name="phone-portrait-outline"></ion-icon>
                            +91 8527203697
                        </a>
                    </li>
                </ul>



            </Container>
        </Navbar>
    );
}

export default logobar
